import React from 'react';
import {
	FixedGrid,
	Shimmer,
	ShimmerPlaceholderText,
	useTheme,
} from '../../../ui';
import { StyledCheckpointQueue } from './checkpoint-queue';
import { StyledCheckpointQueueDescription } from './checkpoint-queue/CheckpointQueueDescription';
import { StyledTile } from './checkpoint-queue/Tile';

export const CheckpointQueuesShimmer = () => (
	<>
		<FixedGrid columns={[2, { mobileXL: 1 }]} itemSelector={Shimmer}>
			<CheckpointQueuePlaceholder />
			<CheckpointQueuePlaceholder />
			<CheckpointQueuePlaceholder />
			<CheckpointQueuePlaceholder />
			<CheckpointQueuePlaceholder />
		</FixedGrid>
	</>
);

const CheckpointQueuePlaceholder = () => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const theme: any = useTheme();

	return (
		<Shimmer>
			<StyledCheckpointQueue>
				<StyledCheckpointQueueDescription>
					<ShimmerPlaceholderText height="1.75em" />
					<p>
						<ShimmerPlaceholderText width="40%" />
					</p>
				</StyledCheckpointQueueDescription>
				<StyledTile backgroundColor={theme.shimmer.placeholder.background} />
			</StyledCheckpointQueue>
		</Shimmer>
	);
};
